import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-js';
import StatusIcon from './StatusIcon';
import { Box, Typography } from '@mui/material';

const Status = ({ statusKey, status, fontSize }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <StatusIcon status={status} />
      <Typography variant="h6">
        <Box
          sx={{
            display: 'flex',
            fontSize: fontSize,
            alignItems: 'center',
            fontWeight: 'regular',
            color: 'text.primary',
          }}
        >
          {i18n.t(`${statusKey}.${status}`)}
        </Box>
      </Typography>
    </Box>
  );
};

Status.propTypes = {
  fontSize: PropTypes.number,
  statusKey: PropTypes.string.isRequired,
  status: PropTypes.oneOf([
    'OPEN',
    'APPROVED',
    'CANCELLED',
    'COMPLETED',
    'INPROGRESS',
    'PENDING_APPROVAL',
    'CLOSED',
    'NONE',
    'FAIL',
    'PREAUTH',
    'DISPUTED',
    'COMPLETE',
    'REFUNDED',
    'PREAUTHREFUNDED',
    'NOTSTARTED',
    'STARTED',
  ]).isRequired,
};

Status.defaultProps = {
  fontSize: 13,
};

export default Status;
